import { AssetGroup } from './asset-group.model';
import { Country } from './country.model';
import { Model } from './model.model';
import { Tag } from './tag.model';
import { Sensor } from '@app/shared/models/sensor.model';

export class Asset {
    id: number;
    name: string;
    description: string;
    manufacturer: string;
    createdAt: Date;
    imageUpdatedAt: Date;
    serial: string;
    status: number;
    customer: string;
    customerAssetTagId: string;
    databaseId: string;
    groups: AssetGroup[];
    tags: Tag[];
    location: {
        address: string;
        address2: string;
        city: string;
        state: string;
        zip: string;
        country?: Country;
    };
    model: Model;
    hrefs: {
        self: string;
        company: string;
        model: string;
    };
    subscribed: boolean;
    subscription: string;
    recommendations: boolean;
    deviceSerialNumber?: boolean;
    sensor?: Sensor;

    get shortName(): string {
        return `${this.name} ${this.description}`;
    }

    get fullName(): string {
        return `${this.manufacturer} ${this.name} ${this.description}`;
    }
}
